import { appContext } from '../../../../AppContext';
import { IbssPage } from '../../../../Components/Core/BasePage/IbssPage';
import { ApiConstants } from '../../../../Providers.Api/ApiConstants';
import { DataHubCredentials } from './DataModels';
import Helper from '../../../../Common/Helper';
import { PagedResponse } from "@iconics/core";
import { JSX } from 'react';
import { IRouterProps, withRouting } from "@iconics/components";
import { SerendieSymbol } from '@serendie/symbols';
import { IRouteParams } from '../Edit/EditDataHubCredentials';
import { Button, ButtonBar, Card, DataGrid, GridContainer, GridItem, IGridData, IGridRowsRequest, IGridRowsResponse, LayoutContainer, LayoutContent, RightButtons } from '@iconics/components';

class ListDataHubCredentials extends IbssPage<IProps, IState>
{
    private get local() { return appContext().localStorageProvider; }

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
            canCreate: this.local.hasRight('DATAMODEL.Tenancy.Create'),  // displayName: TODO proper premission does not exist yet
            dataCredentialsGrid: { rows: [] },
        };
    }

    public async componentDidMount(): Promise<void>
    {
        this.pageTitle = appContext().labels.Platform_DataHubCredentials_PageTitle;
    }

    private async handleRowsRequest(request: IGridRowsRequest<IDataHubCredentials>): Promise<IGridRowsResponse<IDataHubCredentials>>
    {
        const response = await appContext().fadxPlatformApiClientV2.v2.core.byTenancy.dataHubCredentials.get<PagedResponse<DataHubCredentials[]>>({
            select: DataHubCredentials,
            tenancy: appContext().tenantId,
            skipToken: request.skipToken,
            top: request.take,
            orderBy: DataGrid.toODataOrderBy(request.sorter),
        });

        const dataCredentials = response.value.map(x => ({
            id: x.Id,
            name: x.Name,
            eTag: x['@odata.etag'],
            accessKey: x.AccessKey,
            connectionString: x.ConnectionString,
        }));

        return { rows: dataCredentials, nextSkipToken: response.skipToken };
    }

    public render(): JSX.Element
    {
        const labels = appContext().labels;
        return (
            <>
                <LayoutContainer>
                    <LayoutContent>
                        <Card
                            title={labels.Platform_DataHubCredentials_ListTitle}
                            subTitle={labels.Platform_DataHubCredentials_ListSubTitle}
                            icon={<SerendieSymbol name='check-shield' />}
                        >
                            <GridContainer>
                                <GridItem>
                                    <ButtonBar>
                                        <RightButtons>
                                            <Button
                                                size='small'
                                                styleType='ghost'
                                                leftIcon={<SerendieSymbol name='plus' />}
                                                onClick={() => this.props.navigate(`/admin/data-hub-credentials/new`)}
                                                disabled={!this.state.canCreate}
                                            >
                                                {labels.Platform_CommonAction_Add}
                                            </Button>
                                        </RightButtons>
                                    </ButtonBar>
                                </GridItem>
                                <GridItem>
                                    <DataGrid
                                        columns={[
                                            {
                                                columnId: Helper.nameOf<DataHubCredentials>("Name"),
                                                title: labels.DataHubCredentials_Name,
                                                getCellValue: i => i.name,
                                                columnWidth: 100,
                                                sortable: true,
                                            },
                                        ]}
                                        data={this.state.dataCredentialsGrid}
                                        onChange={i => this.setState({ dataCredentialsGrid: i })}
                                        rowId={i => i.id.toString()}
                                        onRowsRequest={i => this.handleRowsRequest(i)}
                                        onCellClicked={i => this.props.navigate(`/admin/data-hub-credentials/${i.id}/edit`)}
                                    />
                                </GridItem>
                            </GridContainer>
                        </Card>
                    </LayoutContent>
                </LayoutContainer>
            </>
        );
    }
}

export default withRouting(ListDataHubCredentials);

export interface IProps extends IRouterProps<IRouteParams>
{
}

export interface IState
{
    canCreate: boolean;
    dataCredentialsGrid: IGridData<IDataHubCredentials>;
}

export interface IDataHubCredentials
{
    id: number;
    name: string;
    accessKey: string;
    connectionString: string;
    eTag: string;
}